import { FeatureType as DbFeatureType } from "@gql/generated/graphql";

export enum FlagsmithFeatureType {
  VIDEO_PLAYER_READY_EVENT = "video_player_ready_event",
  SSO = "sso_enabled",
  HIGHQUALITYVIDEOFIRST = "high_quality_video_first",
  INTERJECTIONS_HANDLING = "interjections_handling",
  REP_SUBMISSION_UPLOADER_TO_MUX = "rep_submission_uploader_to_mux",
  SOCIAL_LEADERBOARD = "social_leaderboard",
  COMMUNITY_BOTTOM = "community_bottom",
  HOME_HERO_SECTION = "home_hero_section",
  SKILL_CARD_WITHOUT_PROGRESS_BAR = "skill_card_without_progress_bar",
  EMBEDDED_WEBAPP = "embedded_webapp",
  HOMEPAGE_2024 = "homepage_2024",
  REP_AI_FEEDBACK = "rep_ai_feedback",
  SENTIMENT_UI = "sentiment_ui",
  DISABLE_MEDIA_UPLOAD = "disable_media_upload",
  USER_RESET_SKILL = "user_reset_skill",
  NEW_AUTH = "new_auth",
  NEW_FORM = "new_form",
}

export const FeatureType = {
  ...DbFeatureType,
  ...FlagsmithFeatureType,
};

export type FeatureType = DbFeatureType | FlagsmithFeatureType;

export enum SourceView {
  REP_THREAD = "rep_thread",
  COACH_PORTFOLIO = "coach portfolio",
  COACH_REPS = "coach_reps",
  LEARNER_REPS = "learner_reps",
  COACH_FEED = "coach_feed",
  COMMUNITY_FEED = "community_feed",
  DASHBOARD = "dashboard",
  COMPLETION_MODAL = "skill_completion_modal",
  WUP = "skill",
  REP_CREATOR = "create_rep",
  LEARNING_PLAN_DETAILS = "learning_plan_details",
  NEXT_SKILL_CARD_HOME_MODULE = "next_skill_home_module",
  COACH_REPS_HOME_MODULE = "coach_reps_home_module",
  SOCIAL_REPS_HOME_MODULE = "social_reps_home_module",
  HERO_SECTION = "hero_section",
}

export enum UserRoles {
  LEARNER = "learner",
  COACH = "coach",
}

export enum StoreUrl {
  APPLE_APP_STORE = "https://apps.apple.com/us/app/bigspring/id1468488854",
  GOOGLE_PLAY_STORE = "https://play.google.com/store/apps/details?id=io.bigspring.learning.training.skills",
}

export enum AppProtocol {
  BIGSPRING = "bigspring://",
}

export enum MediaStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN-PROGRESS",
  COMPLETED = "COMPLETED",
  ABORTED = "ABORTED",
  ERROR = "ERROR",
}

export enum AuthErrorCode {
  TOKEN_GENERATION_FAIL = "TOKEN_GENERATION_FAIL_CODE",
}
